


















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { VueSelect } from "vue-select";

@Component({
  components: { VueSelect },
  name: "TagInput"
})
export default class TagInput extends Vue {
  @Prop({ default: () => [] }) value!: string[];

  internalTags: string[] = [];

  mounted() {
    this.internalTags = [...this.value];
  }

  @Watch('value')
  onValueChanged(val: string[]) {
    this.internalTags = [...val];
  }

  addTag(newTag: string) {
    return newTag.trim();
  }

  emitTags(val: string[]) {
    this.$emit('input', val.filter(Boolean));
    this.$emit('change', val.filter(Boolean));
  }
}
